import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-dialog wise-modal" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { for: "DiscountCode" }
const _hoisted_8 = ["disabled", "placeholder"]
const _hoisted_9 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_10 = { for: "DiscountName" }
const _hoisted_11 = ["disabled", "placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_13 = { class: "col-md-6 form-group" }
const _hoisted_14 = { for: "StartDate" }
const _hoisted_15 = { class: "col-md-6 w-check" }
const _hoisted_16 = { class: "form-check" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  class: "form-check-label",
  for: "HasEndDate"
}
const _hoisted_19 = { for: "StartDate" }
const _hoisted_20 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_21 = { class: "col-md-6 w-check" }
const _hoisted_22 = { class: "form-check" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  class: "form-check-label",
  for: "ApplytoAllClients"
}
const _hoisted_25 = { class: "col-md-6 w-check" }
const _hoisted_26 = { class: "form-check" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  class: "form-check-label",
  for: "ApplytoAllProducts"
}
const _hoisted_29 = {
  key: 1,
  class: "col-md-12 bg-light mb-3"
}
const _hoisted_30 = { class: "mb-2 py-2 d-block text-primary" }
const _hoisted_31 = { class: "cust-zone" }
const _hoisted_32 = { class: "flex-fill" }
const _hoisted_33 = { class: "ms-2 text-danger" }
const _hoisted_34 = ["title", "onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash-fill" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "comp-cont" }
const _hoisted_38 = { value: "" }
const _hoisted_39 = ["value"]
const _hoisted_40 = {
  key: 2,
  class: "col-md-12 bg-light"
}
const _hoisted_41 = { class: "mb-2 py-2 d-block text-primary" }
const _hoisted_42 = { class: "cust-zone" }
const _hoisted_43 = { class: "flex-fill" }
const _hoisted_44 = { class: "ms-2 text-danger" }
const _hoisted_45 = ["title", "onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash-fill" }, null, -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "comp-cont" }
const _hoisted_49 = { value: "" }
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "col-md-6 w-check" }
const _hoisted_52 = { class: "form-check" }
const _hoisted_53 = {
  class: "form-check-label",
  for: "HasRules"
}
const _hoisted_54 = { class: "col-md-6 w-check" }
const _hoisted_55 = { class: "form-check" }
const _hoisted_56 = {
  class: "form-check-label",
  for: "IsStillActive"
}
const _hoisted_57 = { for: "DiscValue" }
const _hoisted_58 = ["disabled", "placeholder"]
const _hoisted_59 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_60 = { class: "modal-footer" }
const _hoisted_61 = { class: "d-flex justify-content-end" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'd-none': !_ctx.visible }, "modal fade show"]),
    style: {"display":"block"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.windowTitle), 1),
          (!_ctx.isSavingRecord)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
                type: "button",
                class: "btn-close"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", { 'has-error': _ctx.v$.dataRecord.DiscountCode.$error }])
            }, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.language.code), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "DiscountCode",
                class: "form-control capletter",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataRecord.DiscountCode) = $event)),
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdDiscount != 0,
                placeholder: '(' + _ctx.language.code.toLowerCase() + ')',
                maxlength: "15",
                autocomplete: "off",
                onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectOnFocus($event)))
              }, null, 40, _hoisted_8), [
                [_vModelText, _ctx.dataRecord.DiscountCode]
              ]),
              (_ctx.v$.dataRecord.DiscountCode.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.v$.dataRecord.DiscountCode.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", { 'has-error': _ctx.v$.dataRecord.DiscountName.$error }])
            }, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.language.name), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "DiscountName",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataRecord.DiscountName) = $event)),
                disabled: _ctx.isSavingRecord,
                placeholder: '(' + _ctx.language.name.toLowerCase() + ')',
                maxlength: "30",
                autocomplete: "off",
                onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectOnFocus($event)))
              }, null, 40, _hoisted_11), [
                [_vModelText, _ctx.dataRecord.DiscountName]
              ]),
              (_ctx.v$.dataRecord.DiscountName.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.v$.dataRecord.DiscountName.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.language.start), 1),
              _createVNode(_component_Datepicker, {
                modelValue: _ctx.dataRecord.StartDate,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataRecord.StartDate) = $event)),
                format: "dd/MM/yyyy",
                cancelText: _ctx.language.cancel,
                selectText: _ctx.language.select,
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdDiscount != 0
              }, null, 8, ["modelValue", "cancelText", "selectText", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "HasEndDate",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dataRecord.HasEndDate) = $event)),
                  disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdDiscount != 0
                }, null, 8, _hoisted_17), [
                  [_vModelCheckbox, _ctx.dataRecord.HasEndDate]
                ]),
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.language.has_end_date), 1)
              ])
            ]),
            (_ctx.dataRecord.HasEndDate)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["col-md-6 form-group", {'has-error': !_ctx.isEndDateCorrect}])
                }, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.language.end), 1),
                  _createVNode(_component_Datepicker, {
                    modelValue: _ctx.dataRecord.EndDate,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dataRecord.EndDate) = $event)),
                    format: "dd/MM/yyyy",
                    cancelText: _ctx.language.cancel,
                    selectText: _ctx.language.select,
                    disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdDiscount != 0
                  }, null, 8, ["modelValue", "cancelText", "selectText", "disabled"]),
                  (!_ctx.isEndDateCorrect)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.language.end_date_error_msg), 1))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "ApplytoAllClients",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dataRecord.ApplytoAllClients) = $event)),
                  onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onApplyClientsChange && _ctx.onApplyClientsChange(...args))),
                  disabled: _ctx.isSavingRecord
                }, null, 40, _hoisted_23), [
                  [_vModelCheckbox, _ctx.dataRecord.ApplytoAllClients]
                ]),
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.language.apply_all_clients), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "ApplytoAllProducts",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dataRecord.ApplytoAllProducts) = $event)),
                  onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onApplyProdsChange && _ctx.onApplyProdsChange(...args))),
                  disabled: _ctx.isSavingRecord
                }, null, 40, _hoisted_27), [
                  [_vModelCheckbox, _ctx.dataRecord.ApplytoAllProducts]
                ]),
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.language.apply_all_prods), 1)
              ])
            ]),
            (!_ctx.dataRecord.ApplytoAllClients)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, [
                    _createTextVNode(_toDisplayString(_ctx.language.selected_customers) + " (", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.selectedCustomers.length), 1),
                    _createTextVNode(") ")
                  ]),
                  _createElementVNode("ul", _hoisted_31, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCustomers, (cust) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: cust.ClientKey
                      }, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(cust.ClientName), 1),
                        _createElementVNode("span", _hoisted_33, [
                          _createElementVNode("a", {
                            class: "text-danger",
                            href: "javascript:;",
                            title: _ctx.language.delete,
                            onClick: ($event: any) => (_ctx.deleteClientFromSelected(cust))
                          }, _hoisted_36, 8, _hoisted_34)
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("li", _hoisted_37, [
                      _createElementVNode("select", {
                        onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.updateApplyCustomer && _ctx.updateApplyCustomer(...args))),
                        class: "selector-comp"
                      }, [
                        _createElementVNode("option", _hoisted_38, _toDisplayString(_ctx.language.select_customer), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (oCust) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: oCust.ClientKey,
                            value: oCust.ClientKey
                          }, _toDisplayString(oCust.ClientName), 9, _hoisted_39))
                        }), 128))
                      ], 32)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.dataRecord.ApplytoAllProducts)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("span", _hoisted_41, [
                    _createTextVNode(_toDisplayString(_ctx.language.selected_products) + " (", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.selectedProducts.length), 1),
                    _createTextVNode(") ")
                  ]),
                  _createElementVNode("ul", _hoisted_42, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedProducts, (cust) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: cust.SKU
                      }, [
                        _createElementVNode("span", _hoisted_43, _toDisplayString(cust.Name), 1),
                        _createElementVNode("span", _hoisted_44, [
                          _createElementVNode("a", {
                            class: "text-danger",
                            href: "javascript:;",
                            title: _ctx.language.delete,
                            onClick: ($event: any) => (_ctx.deleteProductFromSelected(cust))
                          }, _hoisted_47, 8, _hoisted_45)
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("li", _hoisted_48, [
                      _createElementVNode("select", {
                        onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.updateApplyProduct && _ctx.updateApplyProduct(...args))),
                        class: "selector-comp"
                      }, [
                        _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.language.select_product), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (oCust) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: oCust.SKU,
                            value: oCust.SKU
                          }, _toDisplayString(oCust.Name), 9, _hoisted_50))
                        }), 128))
                      ], 32)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "HasRules",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dataRecord.HasRules) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.dataRecord.HasRules]
                ]),
                _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.language.has_rules), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "IsStillActive",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dataRecord.IsStillActive) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.dataRecord.IsStillActive]
                ]),
                _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.language.active), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-6 form-group", { 'has-error': _ctx.v$.dataRecord.DiscValue.$error }])
            }, [
              _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.language.discount), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "DiscValue",
                class: "form-control commav",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dataRecord.DiscValue) = $event)),
                disabled: _ctx.isSavingRecord || _ctx.dataRecord.IdDiscount != 0,
                placeholder: '(' + _ctx.language.discount.toLowerCase() + ')',
                maxlength: "5",
                autocomplete: "off",
                onFocus: _cache[17] || (_cache[17] = ($event: any) => (_ctx.selectOnFocus($event)))
              }, null, 40, _hoisted_58), [
                [_vModelText, _ctx.dataRecord.DiscValue]
              ]),
              (_ctx.v$.dataRecord.DiscValue.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.v$.dataRecord.DiscValue.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary me-2",
              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.closeFormRet && _ctx.closeFormRet(...args))),
              disabled: _ctx.isSavingRecord
            }, _toDisplayString(_ctx.language.close), 9, _hoisted_62),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.saveRecordData && _ctx.saveRecordData(...args))),
              disabled: _ctx.v$.$invalid || !_ctx.isEndDateCorrect || _ctx.isSavingRecord
            }, [
              (_ctx.isSavingRecord)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: ['fa', 'fa-spinner']
                  }))
                : _createCommentVNode("", true),
              (!_ctx.isSavingRecord)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    icon: ['fa', 'fa-save']
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
            ], 8, _hoisted_63)
          ])
        ])
      ])
    ])
  ], 2))
}